module.exports = __webpack_public_path__ + "static/media/github-link.0b2a8d62.svg";